import { z } from 'zod'

const langSchema = z.enum(['en', 'ar']).optional()

export const getSafeLang = () => {
  const storedLang = localStorage.getItem('gcad_lang')?.replace(/"/g, '')
  try {
    return langSchema.parse(storedLang) || 'en'
  } catch (error) {
    return 'en'
  }
}